type AskSnapshot = {
  run?: { id: string; status: string } | null;
  messages: ReadonlyArray<{
    id: string;
    runId?: string | null;
    blocks: ReadonlyArray<{ kind: string; status?: string }>;
  }>;
};

/** The message holding the question the run is waiting on, when it is still unanswered. */
export function openAskMessageId(snapshot: AskSnapshot | null | undefined): string | null {
  const run = snapshot?.run;
  if (!snapshot || run?.status !== "waiting_input") return null;
  for (let index = snapshot.messages.length - 1; index >= 0; index -= 1) {
    const message = snapshot.messages[index];
    if (message?.runId !== run.id) continue;
    if (message.blocks.some((block) => block.kind === "ask" && block.status !== "answered")) {
      return message.id;
    }
  }
  return null;
}
